export default __webpack_public_path__ + "static/media/linky_logo1.838e9cad.png";